import { render, staticRenderFns } from "./CommentsDataTable.vue?vue&type=template&id=693009c0"
import script from "./CommentsDataTable.vue?vue&type=script&lang=js"
export * from "./CommentsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports